import React from "react";
import { useField, useFormikContext, ErrorMessage, Field } from "formik";
import DatePicker from "react-datepicker";

export const RadioField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);

    return (
        <div className="form-check">
            <Field
                className="form-check-input"
                type="radio"
                name={props.name}
                value={props.value} 
                selected={(field.value && field.value == props.value) || null }
            />
            <label className="form-check-label">
                {props.label}
            </label>
        </div>
    );
};

export default RadioField;